export const contrattiMap = [
    { id: 1, nome: "Vendita", slug: "vendita" },
    { id: 2, nome: "Affitto", slug: "affitto" },
    { id: 4, nome: "Affitto Commerciale", slug: "affitto-commerciale" },
    { id: 5, nome: "Affitto Vacanze", slug: "affitto-vacanze" }
];

export const tipologieMap = [
    { id: 1, nome: 'Appartamento', slug: 'appartamento' },
    { id: 2, nome: 'Attico', slug: 'attico' },
    { id: 3, nome: 'Baita/Chalet/Trullo', slug: 'baita-chalet-trullo' },
    { id: 4, nome: 'Garage', slug: 'garage' },
    { id: 5, nome: 'Casa singola', slug: 'casa-singola' },
    { id: 6, nome: 'Casa semindipendente', slug: 'casa-semindipendente' },
    { id: 7, nome: 'Castello', slug: 'castello' },
    { id: 8, nome: 'Loft', slug: 'loft' },
    { id: 9, nome: 'Residence', slug: 'residence' },
    { id: 10, nome: 'Rustico', slug: 'rustico' },
    { id: 11, nome: 'Seminterrato', slug: 'seminterrato' },
    { id: 12, nome: 'Stabile/Palazzo', slug: 'stabile-palazzo' },
    { id: 13, nome: 'Terreno agricolo', slug: 'terreno-agricolo' },
    { id: 14, nome: 'Terreno edif. residenziale', slug: 'terreno-edif-residenziale' },
    { id: 15, nome: 'Villetta a schiera', slug: 'villetta-a-schiera' },
    { id: 16, nome: 'Villetta bifamiliare', slug: 'villetta-bifamiliare' },
    { id: 18, nome: 'Villa', slug: 'villa' },
    { id: 19, nome: 'Agriturismo', slug: 'agriturismo' },
    { id: 20, nome: 'Albergo/Hotel', slug: 'albergo-hotel' },
    { id: 21, nome: 'Attività commerciale', slug: 'attivita-commerciale' },
    { id: 22, nome: 'Azienda agricola', slug: 'azienda-agricola' },
    { id: 23, nome: 'Bar', slug: 'bar' },
    { id: 24, nome: 'Capannone industriale', slug: 'capannone-industriale' },
    { id: 25, nome: 'Discoteca', slug: 'discoteca' },
    { id: 26, nome: 'Laboratorio', slug: 'laboratorio' },
    { id: 27, nome: 'Locale comm.le/Fondo', slug: 'locale-comm-le-fondo' },
    { id: 28, nome: 'Magazzino', slug: 'magazzino' },
    { id: 29, nome: 'Bungalow', slug: 'bungalow' },
    { id: 30, nome: 'Negozio', slug: 'negozio' },
    { id: 31, nome: 'Ristorante', slug: 'ristorante' },
    { id: 32, nome: 'Show Room', slug: 'show-room' },
    { id: 33, nome: 'Terreno ed. ind.le/artig.le', slug: 'terreno-ed-ind-le-artig-le' },
    { id: 34, nome: 'Ufficio', slug: 'ufficio' },
    { id: 35, nome: 'Edificio storico', slug: 'edificio-storico' },
    { id: 36, nome: 'Multiproprietà', slug: 'multiproprieta' },
    { id: 38, nome: 'Porzione di casa', slug: 'porzione-di-casa' },
    { id: 39, nome: 'Terratetto', slug: 'terratetto' },
    { id: 40, nome: 'Villetta trifamiliare', slug: 'villetta-trifamiliare' },
    { id: 41, nome: 'Villetta quadrifamiliare', slug: 'villetta-quadrifamiliare' },
    { id: 42, nome: 'Colonica', slug: 'colonica' },
    { id: 43, nome: 'Fienile', slug: 'fienile' },
    { id: 45, nome: 'Viareggina', slug: 'viareggina' },
    { id: 46, nome: 'Posto barca', slug: 'posto-barca' },
    { id: 47, nome: 'Alimentari', slug: 'alimentari' },
    { id: 48, nome: 'Capannone artigianale', slug: 'capannone-artigianale' },
    { id: 49, nome: 'Capannone commerciale', slug: 'capannone-commerciale' },
    { id: 50, nome: 'Stanza/Posto Letto', slug: 'stanza-posto-letto' },
    { id: 51, nome: 'Pizzeria', slug: 'pizzeria' },
    { id: 52, nome: 'Paninoteca', slug: 'paninoteca' },
    { id: 53, nome: 'Gastronomia', slug: 'gastronomia' },
    { id: 54, nome: 'Pizza a taglio', slug: 'pizza-a-taglio' },
    { id: 55, nome: 'Tabaccheria', slug: 'tabaccheria' },
    { id: 56, nome: 'Annesso agricolo', slug: 'annesso-agricolo' },
    { id: 57, nome: 'Gelateria', slug: 'gelateria' },
    { id: 58, nome: 'Pub', slug: 'pub' },
    { id: 59, nome: 'Rosticceria', slug: 'rosticceria' },
    { id: 60, nome: 'Edicola', slug: 'edicola' },
    { id: 61, nome: 'Cartoleria', slug: 'cartoleria' },
    { id: 62, nome: 'Libreria', slug: 'libreria' },
    { id: 63, nome: 'Bed&Breakfast', slug: 'bed-and-breakfast' },
    { id: 64, nome: 'Bazar', slug: 'bazar' },
    { id: 65, nome: 'Scuderia', slug: 'scuderia' },
    { id: 66, nome: 'Capannone direzionale', slug: 'capannone-direzionale' },
    { id: 67, nome: 'Mansarda', slug: 'mansarda' },
    { id: 68, nome: 'Box', slug: 'box' },
    { id: 69, nome: 'Posto auto', slug: 'posto-auto' },
    { id: 70, nome: 'Open Space', slug: 'open-space' },
    { id: 71, nome: 'Duplex', slug: 'duplex' },
    { id: 72, nome: 'Corte', slug: 'corte' },
    { id: 73, nome: 'Casale', slug: 'casale' },
    { id: 74, nome: 'Villetta a schiera angolare', slug: 'villetta-a-schiera-angolare' },
    { id: 75, nome: 'Panificio', slug: 'panificio' },
    { id: 76, nome: 'Bar/Tabacchi', slug: 'bar-tabacchi' },
    { id: 77, nome: 'Stabilimento balneare', slug: 'stabilimento-balneare' },
    { id: 78, nome: 'Parrucchiere', slug: 'parrucchiere' },
    { id: 79, nome: 'Centro Estetico', slug: 'centro-estetico' },
    { id: 81, nome: 'Riserva di caccia', slug: 'riserva-di-caccia' },
    { id: 82, nome: 'Lavanderia', slug: 'lavanderia' },
    { id: 83, nome: 'Meccanico', slug: 'meccanico' },
    { id: 84, nome: 'Ferramenta/Bricolage', slug: 'ferramenta-bricolage' },
    { id: 85, nome: 'Struttura ricettiva / albergo', slug: 'struttura-ricettiva-albergo' },
    { id: 86, nome: 'Struttura per uso commerciale', slug: 'struttura-per-uso-commerciale' }
];

// Mappa generale per accedere facilmente ai dati
const MAPPING_DATA = {
    tipologia: tipologieMap,
    contratto: contrattiMap,
    // ...aggiungere provincia, comune etc.
};

type FilterType = keyof typeof MAPPING_DATA;

// Funzione per trovare l'ID a partire dallo slug
export const getIdFromSlug = (type: FilterType, slug: string): number | undefined => {
    return MAPPING_DATA[type]?.find(item => item.slug === slug)?.id;
};

// Funzione per trovare lo slug a partire dall'ID
export const getSlugFromId = (type: FilterType, id: number): string | undefined => {
    return MAPPING_DATA[type]?.find(item => item.id === id)?.slug;
};

// Funzione per trovare il nome a partire dall'ID (es. 1 -> "Vendita")
export const getNameFromId = (type: FilterType, id: number): string | undefined => {
    return MAPPING_DATA[type]?.find(item => item.id === id)?.nome;
};

// Funzione per trovare il nome a partire dallo SLUG (es. "vendita" -> "Vendita")
export const getNameFromSlug = (type: FilterType, slug: string): string | undefined => {
    return MAPPING_DATA[type]?.find(item => item.slug === slug)?.nome;
};